import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoTwitter = () => {
  return (
    <g>
      <path d="M16 3.537c-.6.265-1.235.44-1.885.517a3.292 3.292 0 0 0 1.443-1.816 6.572 6.572 0 0 1-2.084.796A3.286 3.286 0 0 0 7.88 6.028a9.32 9.32 0 0 1-6.766-3.43A3.286 3.286 0 0 0 2.13 6.981a3.27 3.27 0 0 1-1.487-.41v.04a3.284 3.284 0 0 0 2.633 3.22c-.484.13-.99.15-1.483.055a3.286 3.286 0 0 0 3.067 2.28A6.586 6.586 0 0 1 0 13.525 9.291 9.291 0 0 0 5.032 15a9.276 9.276 0 0 0 9.34-9.34c0-.142-.004-.283-.01-.424A6.67 6.67 0 0 0 16 3.536z" />
    </g>
  );
};

export default withIcon(IconLogoTwitter);
